import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { RootScopeService } from 'src/app/services/root-scope.service';

@Component({
  selector: 'app-alight-drop-down',
  templateUrl: './alight-drop-down.component.html',
  styleUrls: ['./alight-drop-down.component.scss'],
})
export class AlightDropDownComponent  {
  // Below code to be used and to be removed from multiple places once all the dropdowns are made common.
  @ViewChild(MatSelect) select!: MatSelect;
  @HostListener('window:scroll', [])
  onScroll(): void {
    if (this.select?.panelOpen) {
      this.select.close();
    }
  }


  @Input() group: FormGroup = new FormGroup({}); //form Group name
  @Input() controlName: string = ''; //formControlName
  @Input() autofocus: boolean = false; //Auto Focus page open time
  @Input() list: Array<any> = new Array<any>(); //drop down items
  @Input() label: string = 'name'; //label name
  @Input() value: string = ''; //Selected drop down value
  @Input() disable: boolean = false; //drop down is disable or enabled
  @Input() required: boolean = false; //Drop down selection is required validation
  @Input() description: string = '';
  @Input() selectedValue: any;
  @Output() changeEvent = new EventEmitter(); //change time event

  constructor(public rootScope: RootScopeService) { }


  
  typeHeadChange(event) {
    
    this.group.value[this.controlName] = event.value;
    this.changeEvent.emit(event);
  }

  /**
   * to close any model popup appear in screen 
   */
  openDropDown() {
    if (this.select?.panelOpen) {
      this.rootScope.dropDown = this.select;
    }
  }
}
